// Actions for Payment Term

//import actionType from './actionType';
import {
  GET_PAYMENT_TERMS_LIST,
  GET_PAYMENT_TERMS_LIST_SUCCESS,
  GET_PAYMENT_TERMS_LIST_FAILURE,
  GET_PAYMENT_TERMS_DATA,
  GET_PAYMENT_TERMS_DATA_SUCCESS,
  GET_PAYMENT_TERMS_DATA_FAILURE,
  CREATE_PAYMENT_TERMS,
  CREATE_PAYMENT_TERMS_SUCCESS,
  CREATE_PAYMENT_TERMS_FAILURE,
  UPDATE_PAYMENT_TERMS,
  UPDATE_PAYMENT_TERMS_SUCCESS,
  UPDATE_PAYMENT_TERMS_FAILURE,
  DELETE_PAYMENT_TERMS,
  DELETE_PAYMENT_TERMS_SUCCESS,
  DELETE_PAYMENT_TERMS_FAILURE,
} from "./actionType";

// Get Payment Terms List
export const getPaymentTermsList = () => ({
  type: GET_PAYMENT_TERMS_LIST,
});

export const getPaymentTermsListSuccess = (data) => ({
  type: GET_PAYMENT_TERMS_LIST_SUCCESS,
  payload: data,
});

export const getPaymentTermsListFailure = (error) => ({
  type: GET_PAYMENT_TERMS_LIST_FAILURE,
  payload: error,
});

// Get Payment Terms Data
export const getPaymentTermsData = (id) => ({
  type: GET_PAYMENT_TERMS_DATA,
  payload: id,
});

export const getPaymentTermsDataSuccess = (data) => ({
  type: GET_PAYMENT_TERMS_DATA_SUCCESS,
  payload: data,
});

export const getPaymentTermsDataFailure = (error) => ({
  type: GET_PAYMENT_TERMS_DATA_FAILURE,
  payload: error,
});

// Create Payment Terms
export const createPaymentTerms = (data) => ({
  type: CREATE_PAYMENT_TERMS,
  payload: data,
});

export const createPaymentTermsSuccess = (data) => ({
  type: CREATE_PAYMENT_TERMS_SUCCESS,
  payload: data,
});

export const createPaymentTermsFailure = (error) => ({
  type: CREATE_PAYMENT_TERMS_FAILURE,
  payload: error,
});

// Update Payment Terms
export const updatePaymentTerms = (data) => ({
  type: UPDATE_PAYMENT_TERMS,
  payload: data,
});

export const updatePaymentTermsSuccess = (data) => ({
  type: UPDATE_PAYMENT_TERMS_SUCCESS,
  payload: data,
});

export const updatePaymentTermsFailure = (error) => ({
  type: UPDATE_PAYMENT_TERMS_FAILURE,
  payload: error,
});

// Delete Payment Terms
export const deletePaymentTerms = (id) => ({
  type: DELETE_PAYMENT_TERMS,
  payload: id,
});

export const deletePaymentTermsSuccess = (data) => ({
  type: DELETE_PAYMENT_TERMS_SUCCESS,
  payload: data,
});

export const deletePaymentTermsFailure = (error) => ({
  type: DELETE_PAYMENT_TERMS_FAILURE,
  payload: error,
});
